import * as AuthConstants from '../constants/Auth';

const initialState = {
  forbiddenTriggered: false,
  user: {}
};

export function session(state = initialState, action) {
  switch (action.type) {
    case AuthConstants.FORBIDDEN_TRIGGERED:
      return Object.assign({}, state, {forbiddenTriggered: true});
    case AuthConstants.FORBIDDEN_RESET:
      return Object.assign({}, state, {forbiddenTriggered: false});
    default:
      return state;
  }
}
